import firebaseLogin from './firebaseLogin';
import login from './login';
import logout from './logout';
import { setFullAccessSaga } from './setFullAcccess';

// order of sagas is important
export default [logout, login, setFullAccessSaga, firebaseLogin];
